import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { DataBagService } from 'src/app/common/data-bag.service';
import { Data2Service } from 'src/app/common/data2.service';
import { LoaderService } from 'src/app/common/loader/loader.service';

@Component({
	selector: 'app-accommodation-availability-istour',
	templateUrl: './accommodation-availability-istour.component.html',
	styleUrls: ['./accommodation-availability-istour.component.css'],
})
export class AccommodationAvailabilityIstourComponent implements OnInit {
	products: Array<any> = [];
	product: number = null;
	roomTypesAll: Array<any> = [];
	roomTypes: Array<any> = [];
	roomType: number = null;
	date = {
		from: null,
		to: null,
	};
	contingentAll: Array<any> = [];
	contingent: Array<any> = [];
	fullscreen = 0;
	private occupancy: Array<any> = [];

	constructor(
		private readonly bag: DataBagService,
		private readonly erp: Data2Service,
		private readonly loader: LoaderService,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
		private readonly sidebar: AppComponent,
	) {
		this.route.params.subscribe((params: Params) => {
			if (!params.dateFrom) {
				return;
			}
			if (!params.dateTo) {
				return;
			}
			if (!params.product) {
				return;
			}
			if (!params.roomType) {
				return;
			}
			this.date.from = params.dateFrom;
			this.date.to = params.dateTo;
			this.product = +params.product;
			this.roomType = +params.roomType;
			this.fullscreen = params.fullscreen;

			this.getAvailability();
		});
	}

	ngOnInit(): void {
		this.bag.get('/product/?product_kind__id__in=1&limit=999999', (result, error) => {
			this.products = result.results;
			this.product = +this.product;
			this.productChanged();
		});
		this.bag.get('/product/room/type/?limit=999999', (result, error) => {
			this.roomTypesAll = result.results;
			this.roomType = +this.roomType;
		});
	}

	fullscreenShow() {
		const url =
			'/accommodations/istour/' +
			this.date.from +
			'/' +
			this.date.to +
			'/' +
			this.product +
			'/' +
			this.roomType +
			'/1';
		window.open(
			url,
			'winname',
			'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,width=400,height=350',
		);
	}

	productChanged() {
		if (!this.product || !this.roomTypesAll.length) {
			return;
		}
		console.log(this.roomTypesAll);
		this.roomTypes = this.roomTypesAll; //.filter(obj => obj.productId == this.product)
	}

	settingsChanged() {
		if (!this.date.from) {
			return;
		}
		if (!this.date.to) {
			return;
		}
		if (!this.product) {
			return;
		}
		if (!this.roomType) {
			return;
		}
		this.router.navigate([
			'accommodations',
			'istour',
			this.date.from,
			this.date.to,
			this.product,
			this.roomType,
			this.fullscreen,
		]);
	}

	roomTypeChanged() {
		if (!this.roomType) {
			return;
		}
		this.contingent = this.contingentAll.map((day) => {
			let avaliable: number = this.getRoomAvailability(day.rooms);
			avaliable -= this.getNonameOccupancy(day.day);
			return {
				day: day.day,
				avaliable: avaliable,
			};
		});
	}

	private getAvailability() {
		const data = {
			cmd: 'roomOccupancy',
			dateFrom: this.date.from,
			dateTo: this.date.to,
		};
		this.erp.command('/istour/istourAccommodations', data, (result, error) => {
			this.occupancy = result.data;
			this.getData();
		});
	}

	private getNonameOccupancy(date): number {
		const day = this.occupancy.find((obj) => obj.date == date).rooms;
		const room = day.find((obj) => obj.roomType == this.roomType);
		if (!room) {
			return 0;
		}
		return room.count;
	}

	private getRoomAvailability(rooms): number {
		let avaliable = 0;
		rooms
			.filter((room) => room.roomType.id == this.roomType)
			.forEach((room) => {
				avaliable += room.freeRoomsCount;
			});
		return avaliable;
	}

	private getData() {
		this.loader.show();
		const parms: string = 'lower=' + this.date.from + '&upper=' + this.date.to + '/' + this.product + '/';
		this.bag.get('/product/room/type/count/' + parms, (result, error) => {
			this.contingentAll = result;
			this.loader.hide();
			this.roomTypeChanged();
		});
	}
}
